import common from './common/index.js';
import pages from './pages/index.js';

export default {
  ...common,
  ...pages,
};
